(function () {
  'use strict';

  if (customElements.get('product-swatches')) return;
  class ProductSwatches extends HTMLElement {
    constructor() {
      super();
      
      this.productCard = this.closest('.card-wrapper, product-card');
      this.productForm = this.closest('product-form');
      this.isProductCard = !!this.productCard && !this.productForm;
      
      this.init();
    }

    init() {
      this.setupEventListeners();
      
      if (this.isProductCard) {
        this.setupProductCardBehavior();
      } else {
        this.setupProductPageBehavior();
      }
    }

    setupEventListeners() {
      this.querySelectorAll('.product-swatch__input').forEach(input => {
        input.addEventListener('change', this.handleSwatchChange.bind(this));
      });
    }

    handleSwatchChange(event) {
      const input = event.target;
      const value = input.dataset.optionValue;
      const position = input.dataset.optionPosition;
      
      this.updateDisplayedValue(value);
      
      if (this.isProductCard) {
        event.stopPropagation();
        this.handleProductCardImageSwitch(input);
      } else {
        this.handleProductPageVariantSwitch(input);
      }
      
      this.dispatchEvent(new CustomEvent('swatch:change', {
        bubbles: true,
        detail: { value, position, input }
      }));
    }

    updateDisplayedValue(value) {
      let valueDisplay = this.querySelector('.product-swatches__value');
      
      if (!valueDisplay) {
        valueDisplay = this.querySelector('[data-selected-value]');
      }
      
      if (!valueDisplay) {
        const parentSwatches = this.closest('.product-swatches') || this;
        valueDisplay = parentSwatches.querySelector('.product-swatches__value');
      }
      
      if (valueDisplay) {
        valueDisplay.textContent = value;
      }
    }

    /**
     * Product Card Image Switching
     */
    setupProductCardBehavior() {
      this.storeOriginalImage();
    }

    storeOriginalImage() {
      if (!this.productCard) return;
      
      const mainImage = this.productCard.querySelector('.card img');
      if (mainImage && !mainImage.dataset.originalSrc) {
        mainImage.dataset.originalSrc = mainImage.src;
        mainImage.dataset.originalSrcset = mainImage.srcset || '';
      }
    }

    handleProductCardImageSwitch(input) {
      if (!this.productCard) return;

      const variantImageUrl = input.dataset.variantImage;
      const variantImageId = input.dataset.variantImageId;
      
      if (!variantImageUrl) return;

      const mainImage = this.productCard.querySelector('.card img');
      if (!mainImage) return;

      mainImage.style.opacity = '0.5';
      
      setTimeout(() => {
        mainImage.src = variantImageUrl;
        
        if (input.dataset.variantImageSrcset) {
          mainImage.srcset = input.dataset.variantImageSrcset;
        }
        
        const variantTitle = input.dataset.optionValue;
        if (variantTitle) {
          const currentAlt = mainImage.alt;
          if (!currentAlt.includes(variantTitle)) {
            mainImage.alt = `${currentAlt} - ${variantTitle}`;
          }
        }
        
        mainImage.style.opacity = '1';
      }, 150);
    }

    /**
     * Product Page Variant Switching
     */
    setupProductPageBehavior() {
      this.variantSelector = this.closest('variant-radios, variant-selects');
      
      if (this.variantSelector) {
        this.variantSelector.addEventListener('variant:change', (event) => {
          this.updateSwatchSelection(event.detail);
        });
      }
    }

    handleProductPageVariantSwitch(input) {
      const variantImageUrl = input.dataset.variantImage;
      const variantImageId = input.dataset.variantImageId;
      
      if (variantImageUrl) {
        this.switchProductPageImage(variantImageUrl, variantImageId);
      }
      
      const variantId = input.dataset.variantId;
      
      if (variantId && this.productForm) {
        const hiddenInput = this.productForm.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = variantId;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    switchProductPageImage(imageUrl, imageId) {
      const productMediaWrapper = document.querySelector('.product__media-wrapper, .product__media');
      if (!productMediaWrapper) return;

      if (imageId) {
        const thumbnail = document.querySelector(
          `[data-media-id="${imageId}"], [data-target="${imageId}"], .product__media-item[data-media-id="${imageId}"]`
        );
        if (thumbnail) {
          thumbnail.click();
          return;
        }
      }

      const mainImage = productMediaWrapper.querySelector('img.product__image, img');
      if (mainImage) {
        if (!mainImage.dataset.originalSrc) {
          mainImage.dataset.originalSrc = mainImage.src;
          mainImage.dataset.originalSrcset = mainImage.srcset || '';
        }

        mainImage.style.transition = 'opacity 0.2s ease';
        mainImage.style.opacity = '0.5';
        
        setTimeout(() => {
          mainImage.src = imageUrl;
          
          const baseSrc = imageUrl.split('?')[0];
          mainImage.srcset = `
            ${baseSrc}?width=493 493w,
            ${baseSrc}?width=600 600w,
            ${baseSrc}?width=713 713w,
            ${baseSrc}?width=823 823w,
            ${baseSrc}?width=990 990w,
            ${baseSrc}?width=1100 1100w,
            ${baseSrc}?width=1206 1206w,
            ${baseSrc}?width=1346 1346w,
            ${baseSrc}?width=1426 1426w,
            ${baseSrc}?width=1646 1646w,
            ${baseSrc}?width=1946 1946w
          `.trim();
          
          mainImage.style.opacity = '1';
        }, 200);
      }

      const slider = document.querySelector('slider-component');
      if (slider && imageId) {
        const slideIndex = Array.from(slider.querySelectorAll('.product__media-item')).findIndex(
          item => item.dataset.mediaId === imageId
        );
        if (slideIndex !== -1 && slider.slider) {
          slider.slider.scrollTo({ left: slideIndex * slider.slider.offsetWidth, behavior: 'smooth' });
        }
      }
    }

    updateSwatchSelection(variantData) {
      if (!variantData || !variantData.options) return;

      const optionPosition = this.dataset.optionPosition;
      if (!optionPosition) return;

      const selectedValue = variantData.options[parseInt(optionPosition) - 1];
      if (!selectedValue) return;

      const matchingInput = this.querySelector(
        `.product-swatch__input[data-option-value="${selectedValue}"]`
      );
      
      if (matchingInput && !matchingInput.checked) {
        matchingInput.checked = true;
        this.updateDisplayedValue(selectedValue);
      }
    }
  }

  customElements.define('product-swatches', ProductSwatches);

  document.addEventListener('variant:change', (event) => {
    const productForm = event.target.closest('product-form');
    if (!productForm) return;

    const swatches = productForm.querySelectorAll('product-swatches');
    swatches.forEach(swatch => {
      if (swatch.updateSwatchSelection) {
        swatch.updateSwatchSelection(event.detail);
      }
    });
  });

  function updateSwatchAvailability(productId, availableVariantIds) {
    const productElement = document.querySelector(`[data-product-id="${productId}"]`);
    if (!productElement) return;

    const swatches = productElement.querySelectorAll('.product-swatch__input');
    
    swatches.forEach(input => {
      const variantId = input.dataset.variantId;
      
      if (variantId) {
        const isAvailable = availableVariantIds.includes(parseInt(variantId));
        
        if (isAvailable) {
          input.removeAttribute('data-unavailable');
          input.removeAttribute('aria-disabled');
        } else {
          input.setAttribute('data-unavailable', 'true');
          input.setAttribute('aria-disabled', 'true');
        }
        
        const label = input.nextElementSibling;
        if (label) {
          if (isAvailable) {
            label.removeAttribute('data-unavailable');
          } else {
            label.setAttribute('data-unavailable', 'true');
          }
        }
      }
    });
  }

  window.ProductSwatches = {
    updateAvailability: updateSwatchAvailability
  };
})();
